import { usePopup } from "hooks/usePopup";
import { forwardRef, useState, useImperativeHandle } from "react";
import storageService from "services/storageService";
import { ConfirmationPopup } from "shared";

export const Component = ({ refresh }, ref) => {
  const { addPopup } = usePopup();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});

  const handleData = row => {
    setData(row);
    setIsOpen(true);
  };

  useImperativeHandle(ref, () => ({ handleData }));

  const handleClose = () => setIsOpen(false);

  const handleConfirm = async () => {
    try {
      await storageService.reviewCancellation(data.id, { status: "approved" });
      addPopup({
        type: "success",
        title: "Cancelamento aprovado com sucesso!"
      });
      refresh();
    } catch (err) {
      if (err?.response?.status !== 401) {
        const isAlreadyReviewed = err?.response?.status === 400;
        addPopup({
          type: "error",
          title: isAlreadyReviewed
            ? "Esta movimentação já foi revisada anteriormente."
            : "Erro ao aprovar cancelamento"
        });
      }
    }
  };

  return (
    <ConfirmationPopup
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Aprovar cancelamento"
      message="Deseja realmente aprovar este cancelamento?"
      confirmText="Aprovar"
      cancelText="Cancelar"
      localStorageKey="hideApprovalConfirmation"
    />
  );
};

export const Approve = forwardRef(Component);
